import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import VerbCheckboxInput from '../../../../shared/components/formComponents/inputs/VerbCheckboxInput';

class SectionSelect extends PureComponent {
    static propTypes = {
        selectedItems: PropTypes.object,
        sections: PropTypes.array,
        onChange: PropTypes.func
    };

    _getSections = (sections = []) => {
        const { selectedItems = {} } = this.props;
        if (!Array.isArray(sections)) {
            return [];
        }
        return sections.map((section) => (
            <VerbCheckboxInput
                key={section.id}
                onChange={(active) => this.props.onChange(section.id, active)}
                value={selectedItems[section.id]}
                label={section.name}
            />
        ));
    };

    render() {
        const { sections } = this.props;
        return <div className={'col-sm-12'}>{this._getSections(sections)}</div>;
    }
}

export default SectionSelect;
